import { render, staticRenderFns } from "./IconOnhold.vue?vue&type=template&id=cfaf4f2c&functional=true&"
import script from "./IconOnhold.vue?vue&type=script&lang=js&"
export * from "./IconOnhold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports